import { useRef, useEffect, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { saveCampaignServiceAPI } from 'services/saveCampaign.service';
import { manageCampaignsAPI } from 'services/manageCampaigns.service';
// import { campaignsManageAPI } from 'services/campaignsManage.service';
import { compareDateObjects } from 'utils';
import { manageCampaignsActions } from 'store/actions';
import { useSignal } from '@preact/signals-react';

const MAX_CHART_RANGE = 180;

// function formatDate(date) {
//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, '0');
//   const day = String(date.getDate()).padStart(2, '0');
//   return `${year}-${month}-${day}`;
// }

const doChangesRequest = (data, dateForRequest, newDateForRequest) => {
  if (!data) return true;
  if (!compareDateObjects(newDateForRequest.current, dateForRequest)) {
    return true;
  }
  return false;
};

export const useAPI = () => {
  const dispatch = useDispatch();
  const dateForRequest = useSelector(
    (state) => state.manageCampaigns.selectedDateRange,
    compareDateObjects,
  );

  const fromDate = new Date(dateForRequest.from);
  const toDate = new Date(dateForRequest.to);
  const rangeAtDays = useMemo(
    () => Math.ceil((toDate - fromDate) / (1000 * 60 * 60 * 24)),
    [toDate, fromDate],
  );
  const isValidTimeRange = rangeAtDays < MAX_CHART_RANGE && rangeAtDays > 2;

  const {
    data: tableData,
    isFetching: isFetchingTableData,
    isLoading: isFirstLoadingTableData,
    isError: isErrorTableData,
  } = saveCampaignServiceAPI.useGetCampaignsByDateQuery(dateForRequest, {
    skip: !Object.entries(dateForRequest).length,
  });

  const {
    data: dataChartEvents,
    // isFetching: fetchingDataChartEvents,
    isLoading: isFirstLoadingDataChartEvents,
    isError: isErrorDataChartEvents,
  } = manageCampaignsAPI.useGetCampaignEventsByDatesQuery(dateForRequest, {
    skip: !dateForRequest || !Object.entries(dateForRequest).length || !isValidTimeRange,
  });

  const { isError: isErrorDataChart } = manageCampaignsAPI.useGetGetGraphDataQuery(dateForRequest, {
    skip: !dateForRequest || !Object.entries(dateForRequest).length || !isValidTimeRange,
  });

  useEffect(() => {
    dispatch(
      manageCampaignsActions.updateProperty({
        propField: 'dataChartEvents',
        newValue: dataChartEvents,
      }),
    );
    dispatch(
      manageCampaignsActions.updateProperty({
        propField: 'dataChartEventsError',
        newValue: isErrorDataChartEvents,
      }),
    );
  }, [dataChartEvents]);

  const isError = isErrorDataChart || isErrorDataChartEvents || isErrorTableData;

  // TO-DO refactor from here
  // TO-DO refactor from here
  // TO-DO refactor from here

  const dateForRequest$ = useSignal(dateForRequest);
  const newDateForRequest = useRef(dateForRequest);

  useEffect(() => {
    dateForRequest$.value = dateForRequest;
  }, [dateForRequest]);

  const _campaignids = useMemo(() => {
    if (!tableData?.campaignsData || !tableData?.campaignsData?.length) return false;
    return tableData?.campaignsData?.map(({ _campaignid }) => _campaignid).join(',');
  }, [tableData?.campaignsData]);

  const [action, campaignChangesLogResult] =
    saveCampaignServiceAPI.useLazyGetCampaignChangesLogQuery();

  useEffect(() => {
    if (
      doChangesRequest(campaignChangesLogResult.data, dateForRequest$.value, newDateForRequest) &&
      _campaignids &&
      isValidTimeRange
    ) {
      action({ ...dateForRequest, campaignsIDs: _campaignids });
    }
  }, [
    _campaignids,
    campaignChangesLogResult.data,
    dateForRequest$.value,
    newDateForRequest,
    isValidTimeRange,
  ]);

  // const campaignChangesData$ = useSignal(campaignChangesLogResult);

  useEffect(() => {
    //campaignChangesData$.value = campaignChangesLogResult;
    dispatch(
      manageCampaignsActions.updateProperty({
        propField: 'dataChangesLog',
        newValue: campaignChangesLogResult.data || [],
      }),
    );
    dispatch(
      manageCampaignsActions.updateProperty({
        propField: 'dataChangesLogError',
        newValue: campaignChangesLogResult.isError,
      }),
    );
  }, [campaignChangesLogResult]);

  // TO-DO refactor until here
  // TO-DO refactor until here
  // TO-DO refactor until here

  const openTrackingModal = useCallback((url) => {
    dispatch(
      manageCampaignsActions.updateProperty({
        propField: 'trackingModalUrl',
        newValue: url,
      }),
    );
  }, []);

  return {
    tableData,
    isFetchingTableData,
    isFirstLoadingTableData,
    isFirstLoadingDataChartEvents,
    // campaignChangesData$,
    isError,
    openTrackingModal,
  };
};
